module.exports = __webpack_public_path__ + "static/family-7fe34fd4cca64b11cd9f359bba176214.jpg";